import { render } from "./RegistrationUser.vue?vue&type=template&id=3a5af10a&scoped=true"
import script from "./RegistrationUser.vue?vue&type=script&lang=js"
export * from "./RegistrationUser.vue?vue&type=script&lang=js"

import "./RegistrationUser.vue?vue&type=style&index=0&id=3a5af10a&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a5af10a"]])

export default __exports__